import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { useCodeOfConduct } from '../../Hooks/Features/CodeOfConduct/useCodeOfConduct';
import { SkeletonContainer } from '../Loader/Loader';
import { useCommon } from '../../Hooks/Common/useCommon';
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url
).toString();

function CodeOfConduct() {
    const { numPages, pageWidth, onDocumentLoadSuccess, onSignatureImageChange, savePdfWithSignature, containerRef, signatureImage, pdfFile, loader, tagRef } = useCodeOfConduct();
    const { checkPermission } = useCommon();

    return (
        <>
            <div ref={() => checkPermission("welcomekit", tagRef)}>
                <div ref={tagRef} id='{"tabname": "welcomekit", "data": "code_of_conduct_tab"}'>
                    <div className='d-flex justify-content-center' ref={containerRef} style={{ margin: '0 auto', width: '90%', height: '92vh', overflowY: 'scroll', overflowX: 'hidden', boxSizing: 'border-box' }}>
                        <div>
                            {loader && <SkeletonContainer />}
                            <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
                                {Array.from(new Array(numPages), (_, i) => (
                                    <Page key={`page_${i + 1}`} pageNumber={i + 1} width={pageWidth} />
                                ))}
                            </Document>
                            {numPages && (
                                <div className='mb-4 mx-4 px-4' >
                                    <div className='d-flex justify-content-between align-items-end px-4' >
                                        <div>
                                            {signatureImage && (
                                                <div>
                                                    <img src={signatureImage} alt="Signature preview" width={100} height={100} />
                                                </div>
                                            )}
                                            <label className='' >
                                                Upload Signature:
                                                <input type="file" className="w100" disabled={!numPages} accept="image/*" onChange={(e) => onSignatureImageChange(e)} />
                                                {/* <input type="file" accept="image/png, image/jpeg" onChange={onSignatureImageChange}  /> */}
                                            </label>

                                        </div>
                                        <div>
                                            <button
                                                onClick={savePdfWithSignature}
                                                style={{ marginTop: 10 }}
                                                disabled={!signatureImage}
                                            >
                                                Save & Acknowledge
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
}

export default CodeOfConduct;